<style scoped="" type="text/css">
</style>
<template>
	<el-cascader :disabled="disabled" size="mini" v-model="ids" :options="list" :show-all-levels="false" :clearable="true"
		:props="{ expandTrigger: 'hover',checkStrictly: false  }" @change="change"></el-cascader>
	<!-- <el-date-picker v-model="times" :type="type" :format="format" value-format="timestamp" range-separator="至"
    start-placeholder="开始时间" end-placeholder="结束时间">
  </el-date-picker> -->
</template>
<script type="text/javascript">
	export default {
		name: 'yi_cascader',
		components: {},
		props: {
			disabled: {
				type: Boolean,
				default: false
			},
			id: {
				type: Number,
				default: 0
			},
			list: {
				type: Array,
				default: []
			},

		},
		data() {
			return {
				ids: [],
			}
		},
		watch: {
			id(n, o) {
				this.makeIds()
			},
			list(n, o) {
				this.makeIds()
			}
		},
		created() {
			this.makeIds()

		},

		mounted() {



		},
		computed: {



		},
		methods: {
			makeIds() {
				this.ids = this.findParent(this.id, this.list)
			},
			findParent(childrenId, arr, path) {
				if (path === undefined) {
					path = []
				}
				for (let i = 0; i < arr.length; i++) {
					let tmpPath = path.concat();
					tmpPath.push(arr[i].value);
					if (childrenId == arr[i].value) {
						return tmpPath
					}
					if (arr[i].children) {
						let findResult = this.findParent(childrenId, arr[i].children, tmpPath);
						if (findResult) {
							return findResult
						}
					}
				}
			},

			change() {
				if(this.ids&&this.ids.length>0){
					this.$emit('update:id', this.ids[this.ids.length-1])
				}
				

			}

		}
	}
</script>
